import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';

export interface FileDataCMSModel {
  url: string;
}

export default class FileCMSModel implements CMSModel {
  data: FileDataCMSModel = undefined;

  map(obj: any): void {
    this.data = _.get(obj, 'data', undefined);
  }
}
